import LayoutApp from "@lhd/components/CloneApp/LayoutApp";
import { convertDataToDataForm } from "@lhd/components/CloneApp/untils";
import { AppRecordV2, AppV2, AppSelectionList } from "@lhd/types";
import { Form } from "antd";
import { Styles } from "./styled";
interface IProps {
  dataApp: AppV2;
  appRecord: AppRecordV2;
  selectionDataList?: AppSelectionList;
}
const LaborDocumentPDF = ({
  dataApp,
  appRecord,
  selectionDataList,
}: IProps) => {
  const [form] = Form.useForm();
  const appType = dataApp?.app_type;

  if (appRecord) {
    const result = convertDataToDataForm(
      dataApp?.app_parts || [],
      appRecord,
      true,
    );
    form.setFieldsValue(result);
  }

  return (
    <Styles>
      <Form form={form} disabled>
        <LayoutApp
          form={form}
          dataApp={dataApp}
          appRecord={appRecord}
          appType={appType}
          isEditPage={true}
          isEditing={false}
          isPDF={true}
          selectionDataList={selectionDataList}
        />
      </Form>
    </Styles>
  );
};

export default LaborDocumentPDF;
